/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  Descriptions,
  Card,
} from 'antd';
import ReactJson from 'react-json-view';

import { getEventById } from '../../redux/actions/Event';

const EventDetailsForModal = ({ eventId }) => {
  const dispatch = useDispatch();
  const { event_log: { data } } = useSelector(({ event_log }) => event_log);

  useEffect(() => {
    if (eventId) {
      dispatch(getEventById(eventId));
    }
  }, [dispatch, eventId]);

  return data && data._id ? (
    <div>
      <div className="justify-content-center">
        <Card title={data.server_name}>
          <Descriptions layout="vertical">
            <Descriptions.Item label="Server Name">{data.server_name}</Descriptions.Item>
            <Descriptions.Item label="Kitegateway Reference">{`${data.kitegateway_reference}`}</Descriptions.Item>
            <Descriptions.Item label="EventLog Type">{`${data.event_type}`}</Descriptions.Item>
            <Descriptions.Item label="EventLog Name">{`${data.event_name}`}</Descriptions.Item>
            <Descriptions.Item label="Remark">{`${data.remark}`}</Descriptions.Item>
          </Descriptions>
          <Descriptions layout="vertical">
            <Descriptions.Item label="Input Details" span={3}>
              <ReactJson src={data.input_details} collapsed />
            </Descriptions.Item>
            <Descriptions.Item label="Output Details" span={3}>
              <ReactJson src={data.output_details} collapsed />
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </div>
    </div>
  ) : '';
};

EventDetailsForModal.propTypes = {
  eventId: PropTypes.string,
};

EventDetailsForModal.defaultProps = {
  eventId: '',
};
export default EventDetailsForModal;
